import { AptunoError } from './error.model';

export class AptunoException extends Error {
  public readonly errors: AptunoError[];

  constructor(errors: AptunoError[]) {
    super('At error ocurred');
    this.errors = errors;
  }
}
